import { inject } from '@angular/core';
import {CanActivateFn} from '@angular/router';
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';

export const NavigationProxyGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const configService = inject(ConfigService);

  const culture = configService.getSelectedCulture() || '';
  const fullPath = state.url.replace('/..', '');
  const navState = router.getCurrentNavigation()!.extras || {};

  if (!fullPath.startsWith(`/${culture}`)) { //TODO: CHECK FOR contains culture
    const redirectedUrl = `/${culture}${fullPath}`;
    router.navigateByUrl(redirectedUrl, navState);
    return false;
  }

  return true;
};


